
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0/Types.js";
import { list_type, tuple_type, bool_type, float64_type, record_type, option_type, class_type, union_type, string_type } from "../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { item, map } from "../fable_modules/fable-library-js.5.0.0/Array.js";
import { parse } from "../fable_modules/fable-library-js.5.0.0/Double.js";
import { Point_$reflection, Point } from "./Forecast.js";
import { tryHead, fold, empty } from "../fable_modules/fable-library-js.5.0.0/List.js";
import { tryPick, sortByDescending, toList, min, map as map_2, max, head, average, isEmpty, choose } from "../fable_modules/fable-library-js.5.0.0/Seq.js";
import { map as map_1 } from "../fable_modules/fable-library-js.5.0.0/Option.js";
import { compare } from "../fable_modules/fable-library-js.5.0.0/Date.js";
import { comparePrimitives } from "../fable_modules/fable-library-js.5.0.0/Util.js";

export class SensorId extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["SensorId"];
    }
}

export function SensorId_$reflection() {
    return union_type("StenaWeather.Domain.PortWind.SensorId", [], SensorId, () => [[["Item", string_type]]]);
}

export function SensorId__get_Value(x) {
    return x.fields[0];
}

export class SensorCategory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Other", "Scandinavia", "Baltics", "NorthSea", "IrishSea"];
    }
}

export function SensorCategory_$reflection() {
    return union_type("StenaWeather.Domain.PortWind.SensorCategory", [], SensorCategory, () => [[], [], [], [], []]);
}

export function SensorCategory__ToString(x) {
    switch (x.tag) {
        case 1:
            return "Scandinavia";
        case 2:
            return "Baltics";
        case 3:
            return "North Sea";
        case 4:
            return "Irish Sea";
        default:
            return "Other";
    }
}

export function SensorCategory_Parse_Z721C83C5(s) {
    const matchValue = s.toLowerCase();
    switch (matchValue) {
        case "other":
            return new SensorCategory(0, []);
        case "scandinavia":
            return new SensorCategory(1, []);
        case "baltics":
            return new SensorCategory(2, []);
        case "north sea":
            return new SensorCategory(3, []);
        case "irish sea":
            return new SensorCategory(4, []);
        default:
            return new SensorCategory(0, []);
    }
}

export class DateTimeRange extends Union {
    constructor(Item1, Item2) {
        super();
        this.tag = 0;
        this.fields = [Item1, Item2];
    }
    cases() {
        return ["DateTimeRange"];
    }
}

export function DateTimeRange_$reflection() {
    return union_type("StenaWeather.Domain.PortWind.DateTimeRange", [], DateTimeRange, () => [[["Item1", option_type(class_type("System.DateTimeOffset"))], ["Item2", option_type(class_type("System.DateTimeOffset"))]]]);
}

export class SensorSource extends Record {
    constructor(Name, Link) {
        super();
        this.Name = Name;
        this.Link = Link;
    }
}

export function SensorSource_$reflection() {
    return record_type("StenaWeather.Domain.PortWind.SensorSource", [], SensorSource, () => [["Name", string_type], ["Link", option_type(string_type)]]);
}

export function SensorSource_get_Default() {
    return new SensorSource("Stena owned sensor", undefined);
}

export class QuayVisualType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Default", "Lock"];
    }
}

export function QuayVisualType_$reflection() {
    return union_type("StenaWeather.Domain.PortWind.QuayVisualType", [], QuayVisualType, () => [[], []]);
}

export class Quay extends Record {
    constructor(Label, Orientation, FlipVessel, VisualType) {
        super();
        this.Label = Label;
        this.Orientation = Orientation;
        this.FlipVessel = FlipVessel;
        this.VisualType = VisualType;
    }
}

export function Quay_$reflection() {
    return record_type("StenaWeather.Domain.PortWind.Quay", [], Quay, () => [["Label", string_type], ["Orientation", float64_type], ["FlipVessel", bool_type], ["VisualType", QuayVisualType_$reflection()]]);
}

export function Quay_get_Default() {
    return new Quay("Quay", 0, false, new QuayVisualType(0, []));
}

export function mkBasicQuay(orientation, flipVessel) {
    const bind$0040 = Quay_get_Default();
    return new Quay(bind$0040.Label, orientation * 1, flipVessel, bind$0040.VisualType);
}

/**
 * Parse a location string in the format "latitude,longitude"
 */
export function parseLocation(s) {
    const x_1 = map(parse, map((x) => x.trim(), s.split(",")), Float64Array);
    const Latitude = item(0, x_1);
    return new Point(item(1, x_1), Latitude);
}

export function parseLocationToOption(s) {
    return parseLocation(s);
}

export class SensorMetaData extends Record {
    constructor(SensorId, Name, Category, Imei, Iccid, Location, LocationsExtra, Elevation, Address, Urls, Source, Quays, HiddenWeatherNames, GroupChildrens, Visible, Enabled, IsPublic) {
        super();
        this.SensorId = SensorId;
        this.Name = Name;
        this.Category = Category;
        this.Imei = Imei;
        this.Iccid = Iccid;
        this.Location = Location;
        this.LocationsExtra = LocationsExtra;
        this.Elevation = Elevation;
        this.Address = Address;
        this.Urls = Urls;
        this.Source = Source;
        this.Quays = Quays;
        this.HiddenWeatherNames = HiddenWeatherNames;
        this.GroupChildrens = GroupChildrens;
        this.Visible = Visible;
        this.Enabled = Enabled;
        this.IsPublic = IsPublic;
    }
}

export function SensorMetaData_$reflection() {
    return record_type("StenaWeather.Domain.PortWind.SensorMetaData", [], SensorMetaData, () => [["SensorId", SensorId_$reflection()], ["Name", string_type], ["Category", SensorCategory_$reflection()], ["Imei", option_type(string_type)], ["Iccid", option_type(string_type)], ["Location", option_type(Point_$reflection())], ["LocationsExtra", list_type(tuple_type(string_type, Point_$reflection()))], ["Elevation", option_type(float64_type)], ["Address", option_type(string_type)], ["Urls", list_type(string_type)], ["Source", option_type(SensorSource_$reflection())], ["Quays", list_type(Quay_$reflection())], ["HiddenWeatherNames", list_type(string_type)], ["GroupChildrens", list_type(SensorId_$reflection())], ["Visible", bool_type], ["Enabled", bool_type], ["IsPublic", bool_type]]);
}

export function SensorMetaData_Default(sensorId, category, name) {
    return new SensorMetaData(sensorId, name, category, undefined, undefined, undefined, empty(), undefined, undefined, empty(), undefined, empty(), empty(), empty(), true, true, false);
}

export class PortWindWeather extends Record {
    constructor(SensorId, DateTime, DateTimeMeanStart, ReceivedDelay, WindSpeed, WindSpeedAverage, WindDirection, GustWindSpeed, MaxGustWindSpeed, WaveHeight, TideHeight, TidalFlowSpeed) {
        super();
        this.SensorId = SensorId;
        this.DateTime = DateTime;
        this.DateTimeMeanStart = DateTimeMeanStart;
        this.ReceivedDelay = ReceivedDelay;
        this.WindSpeed = WindSpeed;
        this.WindSpeedAverage = WindSpeedAverage;
        this.WindDirection = WindDirection;
        this.GustWindSpeed = GustWindSpeed;
        this.MaxGustWindSpeed = MaxGustWindSpeed;
        this.WaveHeight = WaveHeight;
        this.TideHeight = TideHeight;
        this.TidalFlowSpeed = TidalFlowSpeed;
    }
}

export function PortWindWeather_$reflection() {
    return record_type("StenaWeather.Domain.PortWind.PortWindWeather", [], PortWindWeather, () => [["SensorId", SensorId_$reflection()], ["DateTime", class_type("System.DateTimeOffset")], ["DateTimeMeanStart", option_type(class_type("System.DateTimeOffset"))], ["ReceivedDelay", option_type(class_type("System.TimeSpan"))], ["WindSpeed", option_type(float64_type)], ["WindSpeedAverage", option_type(float64_type)], ["WindDirection", option_type(float64_type)], ["GustWindSpeed", option_type(float64_type)], ["MaxGustWindSpeed", option_type(float64_type)], ["WaveHeight", option_type(float64_type)], ["TideHeight", option_type(float64_type)], ["TidalFlowSpeed", option_type(float64_type)]]);
}

export function PortWindWeather_Default(dt, sensorId) {
    return new PortWindWeather(sensorId, dt, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

export function PortWindWeatherModule_averageByOptions(f, xs) {
    const xs_1 = choose((arg) => map_1((value) => value, f(arg)), xs);
    if (isEmpty(xs_1)) {
        return undefined;
    }
    else {
        return average(xs_1, {
            GetZero: () => 0,
            Add: (x_1, y) => (x_1 + y),
            DivideByInt: (x, i) => (x / i),
        });
    }
}

export function PortWindWeatherModule_average(xs) {
    let xs_1;
    return new PortWindWeather(head(xs).SensorId, max(map_2((_arg_1) => _arg_1.DateTime, xs), {
        Compare: (x, y) => (compare(x, y) | 0),
    }), min(map_2((_arg_2) => _arg_2.DateTime, xs), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }), (xs_1 = choose((_arg_3) => _arg_3.ReceivedDelay, xs), isEmpty(xs_1) ? undefined : max(xs_1, {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    })), PortWindWeatherModule_averageByOptions((x_3) => x_3.WindSpeed, xs), PortWindWeatherModule_averageByOptions((x_4) => x_4.WindSpeedAverage, xs), PortWindWeatherModule_averageByOptions((x_5) => x_5.WindDirection, xs), PortWindWeatherModule_averageByOptions((x_6) => x_6.GustWindSpeed, xs), PortWindWeatherModule_averageByOptions((x_7) => x_7.MaxGustWindSpeed, xs), PortWindWeatherModule_averageByOptions((x_8) => x_8.WaveHeight, xs), PortWindWeatherModule_averageByOptions((x_9) => x_9.TideHeight, xs), PortWindWeatherModule_averageByOptions((x_10) => x_10.TidalFlowSpeed, xs));
}

export function PortWindWeatherModule_updateByWeatherName(weatherName, value, this$) {
    switch (weatherName) {
        case "WindSpeed":
            return new PortWindWeather(this$.SensorId, this$.DateTime, this$.DateTimeMeanStart, this$.ReceivedDelay, map_1((v) => (v * 1), value), this$.WindSpeedAverage, this$.WindDirection, this$.GustWindSpeed, this$.MaxGustWindSpeed, this$.WaveHeight, this$.TideHeight, this$.TidalFlowSpeed);
        case "WindSpeedAverage":
            return new PortWindWeather(this$.SensorId, this$.DateTime, this$.DateTimeMeanStart, this$.ReceivedDelay, this$.WindSpeed, map_1((v_1) => (v_1 * 1), value), this$.WindDirection, this$.GustWindSpeed, this$.MaxGustWindSpeed, this$.WaveHeight, this$.TideHeight, this$.TidalFlowSpeed);
        case "WindDirection":
            return new PortWindWeather(this$.SensorId, this$.DateTime, this$.DateTimeMeanStart, this$.ReceivedDelay, this$.WindSpeed, this$.WindSpeedAverage, map_1((v_2) => (v_2 * 1), value), this$.GustWindSpeed, this$.MaxGustWindSpeed, this$.WaveHeight, this$.TideHeight, this$.TidalFlowSpeed);
        case "GustWindSpeed":
            return new PortWindWeather(this$.SensorId, this$.DateTime, this$.DateTimeMeanStart, this$.ReceivedDelay, this$.WindSpeed, this$.WindSpeedAverage, this$.WindDirection, map_1((v_3) => (v_3 * 1), value), this$.MaxGustWindSpeed, this$.WaveHeight, this$.TideHeight, this$.TidalFlowSpeed);
        case "MaxGustWindSpeed":
            return new PortWindWeather(this$.SensorId, this$.DateTime, this$.DateTimeMeanStart, this$.ReceivedDelay, this$.WindSpeed, this$.WindSpeedAverage, this$.WindDirection, this$.GustWindSpeed, map_1((v_4) => (v_4 * 1), value), this$.WaveHeight, this$.TideHeight, this$.TidalFlowSpeed);
        case "WaveHeight":
            return new PortWindWeather(this$.SensorId, this$.DateTime, this$.DateTimeMeanStart, this$.ReceivedDelay, this$.WindSpeed, this$.WindSpeedAverage, this$.WindDirection, this$.GustWindSpeed, this$.MaxGustWindSpeed, map_1((v_5) => (v_5 * 1), value), this$.TideHeight, this$.TidalFlowSpeed);
        case "TideHeight":
            return new PortWindWeather(this$.SensorId, this$.DateTime, this$.DateTimeMeanStart, this$.ReceivedDelay, this$.WindSpeed, this$.WindSpeedAverage, this$.WindDirection, this$.GustWindSpeed, this$.MaxGustWindSpeed, this$.WaveHeight, map_1((v_6) => (v_6 * 1), value), this$.TidalFlowSpeed);
        case "TidalFlowSpeed":
            return new PortWindWeather(this$.SensorId, this$.DateTime, this$.DateTimeMeanStart, this$.ReceivedDelay, this$.WindSpeed, this$.WindSpeedAverage, this$.WindDirection, this$.GustWindSpeed, this$.MaxGustWindSpeed, this$.WaveHeight, this$.TideHeight, map_1((v_7) => (v_7 * 1), value));
        default:
            return this$;
    }
}

export function PortWindWeatherModule_hideValuesByWeatherNames(weatherNames, weather) {
    return fold((w, n) => PortWindWeatherModule_updateByWeatherName(n, undefined, w), weather, weatherNames);
}

/**
 * Merges weather items into a single one, taking the most recent non-None value for each field.
 * Needed when a single sensor's values are split across multiple items (e.g. wind and tide separately).
 */
export function PortWindWeatherModule_mergeLatest(xs) {
    const sorted = toList(sortByDescending((_arg) => _arg.DateTime, xs, {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const pick = (f) => tryPick(f, sorted);
    return map_1((latest) => (new PortWindWeather(latest.SensorId, latest.DateTime, pick((_arg_1) => _arg_1.DateTimeMeanStart), pick((_arg_2) => _arg_2.ReceivedDelay), pick((_arg_3) => _arg_3.WindSpeed), pick((_arg_4) => _arg_4.WindSpeedAverage), pick((_arg_5) => _arg_5.WindDirection), pick((_arg_6) => _arg_6.GustWindSpeed), pick((_arg_7) => _arg_7.MaxGustWindSpeed), pick((_arg_8) => _arg_8.WaveHeight), pick((_arg_9) => _arg_9.TideHeight), pick((_arg_10) => _arg_10.TidalFlowSpeed))), tryHead(sorted));
}

export class PortWindWeatherResult extends Record {
    constructor(Weather, LastUpdated, Location, WindSpeedAverageRange, IsFallbackData) {
        super();
        this.Weather = Weather;
        this.LastUpdated = LastUpdated;
        this.Location = Location;
        this.WindSpeedAverageRange = WindSpeedAverageRange;
        this.IsFallbackData = IsFallbackData;
    }
}

export function PortWindWeatherResult_$reflection() {
    return record_type("StenaWeather.Domain.PortWind.PortWindWeatherResult", [], PortWindWeatherResult, () => [["Weather", list_type(PortWindWeather_$reflection())], ["LastUpdated", class_type("System.DateTimeOffset")], ["Location", option_type(Point_$reflection())], ["WindSpeedAverageRange", option_type(class_type("System.TimeSpan"))], ["IsFallbackData", bool_type]]);
}

